import React from 'react';
import { Button, Input, Space, Card, Row, Col } from 'antd';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { DirectoryValue } from '../../types/directory';
import { SelectDirectory } from './Select';

interface DirectoryValuesInputProps {
  values: DirectoryValue[];
  onChange: (values: DirectoryValue[]) => void;
}

const DirectoryValueCard: React.FC<{
  value: DirectoryValue;
  onChange: (updated: Partial<DirectoryValue>) => void;
  onDelete: () => void;
}> = ({ value, onChange, onDelete }) => (
  <Card
    size="small"
    extra={
      <Space>
        <Button type="link" href="/admin/directory/new" target="_blank">
          New
        </Button>
        <Button type="text" danger icon={<DeleteOutlined />} onClick={onDelete} />
      </Space>
    }>
    <Row gutter={[8, 8]}>
      <Col span={24} lg={6}>
        <Input
          placeholder="Name"
          value={value.name}
          onChange={e => onChange({ name: e.target.value })}
        />
      </Col>
      <Col span={24} lg={6}>
        <Input
          placeholder="Description"
          value={value.description}
          onChange={e => onChange({ description: e.target.value })}
        />
      </Col>
      <Col span={24} lg={12}>
        <SelectDirectory value={value.directory} onChange={directory => onChange({ directory })} />
      </Col>
    </Row>
  </Card>
);

export const DirectoryValuesInput: React.FC<DirectoryValuesInputProps> = ({ values, onChange }) => {
  const updateValue = (index: number, update: Partial<DirectoryValue>) =>
    onChange(values.map((v, i) => (i === index ? { ...v, ...update } : v)));

  return (
    <Space direction="vertical" style={{ width: '100%' }} size="middle">
      {values.map((value, index) => (
        <DirectoryValueCard
          key={index}
          value={value}
          onChange={update => updateValue(index, update)}
          onDelete={() => onChange(values.filter((_, i) => i !== index))}
        />
      ))}
      <Button
        type="dashed"
        icon={<PlusOutlined />}
        onClick={() => onChange([...values, { name: '', description: '' }])}
        block>
        Add Value
      </Button>
    </Space>
  );
};
